module.exports = __webpack_public_path__ + "static/media/centroid_distances.4e6f3e35.png";